import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontfamily/fontfamilyediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontFamilyCommand from "./fontfamilycommand";
import { normalizeOptions } from "./utils";
import { buildDefinition, FONT_FAMILY } from "../utils";
/**
 * The font family editing feature.
 *
 * It introduces the {@link module:font/fontfamily/fontfamilycommand~FontFamilyCommand command} and
 * the `fontFamily` attribute in the {@link module:engine/model/model~Model model} which renders
 * in the {@link module:engine/view/view view} as an inline `<span>` element (`<span style="font-family: Arial">`),
 * depending on the {@link module:font/fontfamily~FontFamilyConfig configuration}.
 *
 * @extends module:core/plugin~Plugin
 */

var FontFamilyEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(FontFamilyEditing, _Plugin);

  _createClass(FontFamilyEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'FontFamilyEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function FontFamilyEditing(editor) {
    var _this;

    _classCallCheck(this, FontFamilyEditing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FontFamilyEditing).call(this, editor)); // Define default configuration using font families shortcuts.

    editor.config.define(FONT_FAMILY, {
      options: ['default', 'Arial, Helvetica, sans-serif', 'Courier New, Courier, monospace', 'Georgia, serif', 'Lucida Sans Unicode, Lucida Grande, sans-serif', 'Tahoma, Geneva, sans-serif', 'Times New Roman, Times, serif', 'Trebuchet MS, Helvetica, sans-serif', 'Verdana, Geneva, sans-serif']
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontFamilyEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor; // Allow fontFamily attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: FONT_FAMILY
      });
      editor.model.schema.setAttributeProperties(FONT_FAMILY, {
        isFormatting: true,
        copyOnEnter: true
      }); // Get configured font family options without "default" option.

      var options = normalizeOptions(editor.config.get('fontFamily.options')).filter(function (item) {
        return item.model;
      });
      var definition = buildDefinition(FONT_FAMILY, options); // Set-up the two-way conversion.

      editor.conversion.attributeToElement(definition);
      editor.commands.add(FONT_FAMILY, new FontFamilyCommand(editor));
    }
  }]);

  return FontFamilyEditing;
}(Plugin);

export { FontFamilyEditing as default };